<template>
  <div class="anti-counterfeit-page">
    <main class="main-content">
      <div class="container">
        <div class="verify-card">
          <div class="card-header">
            <h2>官方防伪验证</h2>
            <p class="tag">璟点官方认证 · 正品保障</p>
          </div>

          <div class="verify-form">
            <div class="form-item code-form-item">
              <label class="form-label">防伪码</label>
              <div class="code-input-wrap">
                <input v-model="verifyForm.antiCode" placeholder="请输入商品外包装上的16位防伪码" maxlength="16" class="code-input"
                       @blur="validateAntiCode">
                <span class="word-limit">{{ verifyForm.antiCode.length }}/16</span>
                <span class="close-icon" @click="clearCode" v-if="verifyForm.antiCode">
                  <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M689.9 395.1c9.9 9.9 9.9 25.9 0 35.8L535.8 576l154.1 145c9.9 9.9 9.9 25.9 0 35.8-9.9 9.9-25.9 9.9-35.8 0L512 611.8 357.9 756.9c-9.9 9.9-25.9 9.9-35.8 0-9.9-9.9-9.9-25.9 0-35.8L488.2 576 334.1 431c-9.9-9.9-9.9-25.9 0-35.8 9.9-9.9 25.9-9.9 35.8 0L512 540.2l154.1-145.1c9.8-9.8 25.8-9.8 35.6 0z"
                        fill="#9ca3af" />
                  </svg>
                </span>
                <div class="error-tip" v-if="errorMsg.antiCode">{{ errorMsg.antiCode }}</div>
              </div>
            </div>

            <div class="btn-group">
              <button class="verify-btn" @click="product" :class="{ loading: loading }" :disabled="loading">
                <span class="btn-text" v-if="!loading">立即验证</span>
                <span class="loading-icon" v-else>
                  <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M512 104c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416S741.8 104 512 104zm0 776c-200.2 0-364-163.8-364-364s163.8-364 364-364 364 163.8 364 364-163.8 364-364 364z"
                        fill="#fff" />
                    <path
                        d="M689.9 720c-3.5 3.6-8 5.7-12.8 5.7H425c-6.5 0-12.3-4.1-14.8-10-5.4-14.1 2.1-30.2 16.2-35.6l224-88c14.1-5.4 30.2 2.1 35.6 16.2 5.4 14.1-2.1 30.2-16.2 35.6L506 665.8l167.9 66.2z"
                        fill="#fff" />
                  </svg>
                </span>
              </button>
            </div>

            <div class="result-box" v-if="showResult">
              <div class="success-result"
                   v-if="verifyResult.success || verifyResult.state === 1 || verifyResult.state === 3">
                <div class="result-icon success">
                  <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                        fill="#e6a23c" />
                    <path
                        d="M749.1 374.9c-9.9-9.9-25.9-9.9-35.8 0L448 642.7 310.7 505.3c-9.9-9.9-25.9-9.9-35.8 0s-9.9 25.9 0 35.8l163.1 163.1c9.9 9.9 25.9 9.9 35.8 0l295.1-295.1c9.8-9.9 9.8-25.9 0-35.8z"
                        fill="#e6a23c" />
                  </svg>
                </div>
                <div class="result-info">
                  <h3>验证成功 ✔</h3>
                  <p class="desc">该商品为璟点官方正品，享受全国联保服务</p>
                  <div class="result-detail">
                    <div class="detail-item">
                      <span class="value">{{ verifyResult.productname }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="value">{{ verifyResult.productmodel }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="label">序列码：</span>
                      <span class="value">{{ verifyResult.productNumber }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="label">经销商：</span>
                      <span class="value">{{ verifyResult.customer }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="label">防伪码：</span>
                      <span class="value">{{ verifyForm.antiCode }}</span>
                    </div>
                    <div v-if="verifyResult.times > 1" class="detail-item content" v-html="verifyResult.content"></div>
                    <div class="auth-tag">璟点官方认证 · 全国连锁保障</div>
                  </div>
                </div>
              </div>

              <div class="error-result" v-else>
                <div class="result-icon error">
                  <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                        fill="#999" />
                    <path
                        d="M689.9 395.1c9.9 9.9 9.9 25.9 0 35.8L535.8 576l154.1 145c9.9 9.9 9.9 25.9 0 35.8-9.9 9.9-25.9 9.9-35.8 0L512 611.8 357.9 756.9c-9.9 9.9-25.9 9.9-35.8 0-9.9-9.9-9.9-25.9 0-35.8L488.2 576 334.1 431c-9.9-9.9-9.9-25.9 0-35.8 9.9-9.9 25.9-9.9 35.8 0L512 540.2l154.1-145.1c9.8-9.8 25.8-9.8 35.6 0z"
                        fill="#999" />
                  </svg>
                </div>
                <div class="result-info">
                  <h3>验证失败 ❌</h3>
<!--                  <p v-html="verifyResult.content"></p>-->
                  <div class="result-detail">
                    <div class="detail-item">
                      <span class="label">防伪码：</span>
                      <span class="value">{{ verifyForm.antiCode }}</span>
                    </div>
                    <div class="detail-item tips">
                      请通过璟点官方渠道购买正品
                    </div>
                    <div class="auth-tag">璟点官方提醒 · 远离假冒产品</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import {checkPortalNfc} from "@/api/sales";

export default {
  name: "AntiCounterfeit", // Vue2 推荐声明组件名，便于调试
  data() {
    // 替换 Vue3 的 ref/reactive，所有响应式数据集中管理
    return {
      verifyForm: {
        antiCode: ""
      },
      errorMsg: {
        antiCode: ""
      },
      loading: false,
      showResult: false,
      verifyResult: {
        success: false,
        time: "",
        state: 0,
        content: "",
        productname: "",
        productmodel: "",
        productNumber: '',
        price: "",
        url: "",
        customer: "",
        times: "",
      }
    };
  },
  mounted() {
    // 替换 Vue3 的 onMounted 生命周期钩子
    const code = this.getQueryString("fwcode");
    if (code) {
      this.verifyForm.antiCode = code;
      this.validateAntiCode();
    }
  },
  methods: {
    // 所有函数移入 methods，通过 this 访问响应式数据
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    validateAntiCode() {
      if (!this.verifyForm.antiCode.trim()) {
        this.errorMsg.antiCode = "请输入防伪码";
        return false;
      }
      if (this.verifyForm.antiCode.length !== 16) {
        this.errorMsg.antiCode = "防伪码必须为16位";
        return false;
      }
      this.errorMsg.antiCode = "";
      return true;
    },
    clearCode() {
      this.verifyForm.antiCode = "";
      this.errorMsg.antiCode = "";
    },

    //根据序列号再次查询真伪
    async checkPortalNfc(code) {
      try {
        const res = await checkPortalNfc(code); // 等待接口返回
        if (res.code === 200) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.error("checkPortalNfc接口调用失败：", error);
        return false; // 异常时返回false，避免程序中断
      }
    },

    async product() {
      const isValid = this.validateAntiCode();
      if (!isValid) return;

      this.loading = true;
      this.showResult = false;

      try {
        // 修正接口地址格式（原代码已无多余//，保留正确格式）
        const res = await axios.get(
            `http://predator.qima315.com/Api/ProductExternal/GetScale?scode=${encodeURIComponent(this.verifyForm.antiCode.trim())}`,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            }
        );

        if (res.data.success) {
          const data = res.data.data || {};

          const flag = await this.checkPortalNfc(data.productNumber.trim());
          //测试数据
          // const flag = await this.checkPortalNfc('4O57B3');
          if(flag){
            this.showResult = true;
            this.verifyResult.success = true;
            this.verifyResult.state = 1;


            this.verifyResult.productname = data.productname || "未获取到产品名称";
            this.verifyResult.productmodel = data.productmodel || "未获取到产品型号";
            this.verifyResult.price = data.price || "未获取到价格";
            this.verifyResult.customer = data.Customer || "未获取到经销商";

            this.verifyResult.productNumber = data.productNumber || "未获取到序列码";


            const result = await axios.post(
                "https://fw.qima315.com/api/CodeQuery",
                `custno=XSHC169AAAA017&fwcode=${encodeURIComponent(this.verifyForm.antiCode.trim())}&lang=zh-en`,
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                  }
                }
            );
            this.verifyResult.times = result.data.data.Times;
            this.verifyResult.content = `此防伪码当前为第${result.data.data.Times}次查询,首次查询时间:${result.data.data.FirstDate},谨防假冒!`;
            console.log(result);

          }else{
            this.showResult = true;
            this.verifyResult.success = false;
            this.verifyResult.state = 0;
            this.verifyResult.content = res.data.message || "条码不存在";
            this.verifyResult.productname = "";
            this.verifyResult.productmodel = "";
            this.verifyResult.price = "";
            this.verifyResult.customer = "";
          }

          // this.showResult = true;
          // this.verifyResult.success = true;
          // this.verifyResult.state = 1;
          //
          //
          // this.verifyResult.productname = data.productname || "未获取到产品名称";
          // this.verifyResult.productmodel = data.productmodel || "未获取到产品型号";
          // this.verifyResult.price = data.price || "未获取到价格";
          // this.verifyResult.customer = data.Customer || "未获取到经销商";

          // const result = await axios.post(
          //     "https://fw.qima315.com/api/CodeQuery",
          //     `custno=XSHC169AAAA017&fwcode=${encodeURIComponent(this.verifyForm.antiCode.trim())}&lang=zh-en`,
          //     {
          //       headers: {
          //         "Content-Type": "application/x-www-form-urlencoded"
          //       }
          //     }
          // );
          // this.verifyResult.times = result.data.data.Times;
          // this.verifyResult.content = `此防伪码当前为第${result.data.data.Times}次查询,首次查询时间:${result.data.data.FirstDate},谨防假冒!`;
          // console.log(result);

        } else {
          this.showResult = true;
          this.verifyResult.success = false;
          this.verifyResult.state = 0;
          this.verifyResult.content = res.data.message || "条码不存在";
          this.verifyResult.productname = "";
          this.verifyResult.productmodel = "";
          this.verifyResult.price = "";
          this.verifyResult.customer = "";
        }
      } catch (error) {
        console.error("验证错误：", error);
        this.showResult = true;
        this.verifyResult.success = false;
        this.verifyResult.state = 0;
        this.verifyResult.content = "网络异常或接口请求失败，请刷新页面后重试";
        this.verifyResult.productname = "";
        this.verifyResult.productmodel = "";
        this.verifyResult.price = "";
        this.verifyResult.customer = "";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

button,
input {
  font-family: "Microsoft Yahei", "PingFang SC", sans-serif;
  border: none;
  outline: none;
}

.anti-counterfeit-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  font-family: "Microsoft Yahei", "PingFang SC", sans-serif;
  color: #333;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.main-content {
  flex: 1;
  padding: 50px 0;
}

.verify-card {
  background-color: #fff;
  border: 1px solid #eee;
  padding: 50px;
  margin-bottom: 40px;
  position: relative;
}

.verify-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 5px;
  background-color: #e6a23c;
}

.card-header {
  text-align: center;
  margin-bottom: 40px;
}

.card-header h2 {
  font-size: 32px;
  color: #1a1a1a;
  margin: 0 0 10px 0;
  font-weight: bold;
}

.card-header .tag {
  font-size: 16px;
  color: #e6a23c;
  letter-spacing: 2px;
}

.verify-form {
  width: 100%;
  max-width: 550px;
  margin: 0 auto;
}

.form-item {
  margin-bottom: 30px;
}

.form-label {
  display: block;
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 500;
}

.code-input-wrap {
  position: relative;
  width: 100%;
}

.code-input {
  width: 100%;
  height: 50px;
  border-radius: 4px;
  border: 1px solid #ddd;
  padding: 0 45px 0 20px;
  font-size: 16px;
  transition: all 0.2s ease;
}

.code-input:focus {
  border-color: #e6a23c;
  box-shadow: 0 0 0 3px rgba(230, 162, 60, 0.1);
}

.word-limit {
  position: absolute;
  right: 45px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #999;
}

.close-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 20px;
  height: 20px;
  transition: all 0.2s ease;
}

.close-icon:hover .icon {
  fill: #666;
}

.error-tip {
  position: absolute;
  left: 0;
  bottom: -20px;
  font-size: 12px;
  color: #f56c6c;
  line-height: 1;
}

.btn-group {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-bottom: 30px;
}

.verify-btn {
  padding: 12px 50px;
  font-size: 16px;
  border-radius: 4px;
  background-color: #e6a23c;
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.verify-btn:hover:not(:disabled) {
  background-color: #d39025;
}

.verify-btn:disabled {
  background-color: #f0c879;
  cursor: not-allowed;
}

.loading-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-icon .icon {
  width: 20px;
  height: 20px;
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.reset-btn {
  padding: 12px 50px;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: #fff;
  color: #666;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.reset-btn:hover:not(:disabled) {
  border-color: #ccc;
  background-color: #f9f9f9;
}

.reset-btn:disabled {
  color: #ccc;
  border-color: #eee;
  cursor: not-allowed;
}

.result-box {
  margin-top: 30px;
  padding: 30px;
  border-radius: 4px;
  border: 1px solid #eee;
  background-color: #fafafa;
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.success-result,
.warning-result,
.error-result {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.result-icon {
  flex-shrink: 0;
  margin-top: 5px;
}

.result-icon .icon {
  width: 40px;
  height: 40px;
}

.result-info h3 {
  font-size: 20px;
  margin: 0 0 10px 0;
  font-weight: 600;
}

.success-result h3 {
  color: #e6a23c;
}

.warning-result h3 {
  color: #e6a23c;
}

.error-result h3 {
  color: #999;
}

.result-info .desc {
  font-size: 15px;
  color: #666;
  margin: 0 0 15px 0;
}

.result-detail {
  width: 100%;
}

.detail-item {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
  line-height: 1.8;
}

.detail-item .label {
  font-weight: 500;
  color: #333;
  margin-right: 8px;
}

.detail-item.content {
  color: #666;
  padding-left: 0;
  margin-top: 10px;
}

.detail-item.tips {
  color: #999;
  font-size: 13px;
  margin-top: 10px;
}

.auth-tag {
  display: inline-block;
  margin-top: 15px;
  padding: 4px 12px;
  background-color: rgba(230, 162, 60, 0.1);
  color: #e6a23c;
  font-size: 13px;
  border-radius: 20px;
}

.brand-info {
  text-align: center;
  padding: 30px 0;
  border-top: 1px solid #eee;
}

.brand-slogan {
  font-size: 18px;
  color: #333;
  font-weight: 500;
  margin-bottom: 10px;
}

.brand-contact {
  font-size: 14px;
  color: #666;
}

.page-footer {
  background-color: #1a1a1a;
  color: #999;
  padding: 20px 0;
  font-size: 13px;
  text-align: center;
}

@media (max-width: 768px) {
  .page-header {
    padding: 10px 0;
  }

  .brand-logo {
    float: none;
    justify-content: center;
    margin-bottom: 10px;
  }

  .brand-tagline {
    float: none;
    text-align: center;
  }

  .verify-card {
    padding: 30px 20px;
  }

  .card-header h2 {
    font-size: 26px;
  }

  .success-result,
  .warning-result,
  .error-result {
    flex-direction: column;
    gap: 15px;
  }

  .result-icon {
    margin: 0 auto 10px;
  }

  .result-info {
    text-align: center;
  }

  .btn-group {
    flex-direction: column;
  }

  .verify-btn,
  .reset-btn {
    width: 100%;
  }
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>